import { PlayerFeatureOptions } from 'common/features/player/types';

export interface SubmissionOptions extends PlayerFeatureOptions {
    panes: TabPane[];
    plagiarismThreshold: number;
    questionWithUploadOverlayURL?: string;
    page?: number;
}

export enum TabPaneTypes {
    SUBMISSION = 'submission',
    QUESTION_PREVIEW = 'questionPreview',
    ATTACHMENT = 'attachment',
    PLAGIARISM = 'plagiarism',
    STIMULUS = 'stimulus',
    DRAWING = 'drawing',
    MODEL_ANSWERS = 'modelAnswers',
}

export interface AttachmentData {
    externalDeliveryId: number;
    externalDeliveryFileName: string;
    externalDeliveryMimeType: string;
}

export interface DrawingData {
    contentItemId?: string;
    fileName?: string;
    imageUrl?: string;
    presignedUrls?: {
        [s3Uri: string]: string;
    };
    imageS3Uri?: string;
}

export type TabPane = TabPaneTypes.SUBMISSION | TabPaneTypes.QUESTION_PREVIEW |
    TabPaneTypes.ATTACHMENT | TabPaneTypes.PLAGIARISM | TabPaneTypes.STIMULUS | TabPaneTypes.DRAWING |
    TabPaneTypes.MODEL_ANSWERS;

export type TabStorageData = {
    id: string;
    tabId: string;
};

export const TAB_STORAGE_KEY = 'lastActiveTabForSubmissionFeature';
